import script from "./BoilerItemPatternModal.vue?vue&type=script&setup=true&lang=js"
export * from "./BoilerItemPatternModal.vue?vue&type=script&setup=true&lang=js"

import "./BoilerItemPatternModal.vue?vue&type=style&index=0&id=520912e6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-520912e6"]])

export default __exports__